var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivetyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.75C6.80008 22.75 2.58008 18.52 2.58008 13.33C2.58008 11.46 3.13008 9.65001 4.17008 8.09001C4.40008 7.75001 4.87008 7.65001 5.21008 7.88001C5.55008 8.11001 5.65008 8.58001 5.42008 8.92001C4.55008 10.22 4.09008 11.75 4.09008 13.32C4.09008 17.69 7.64008 21.24 12.0101 21.24C16.3801 21.24 19.9301 17.69 19.9301 13.32C19.9301 8.95001 16.3701 5.40001 12.0001 5.40001C11.0801 5.40001 10.1801 5.53001 9.33008 5.79001C8.93008 5.91001 8.51008 5.69001 8.39008 5.29001C8.27008 4.89001 8.49008 4.47001 8.89008 4.35001C9.89008 4.05001 10.9301 3.89001 12.0001 3.89001C17.2001 3.89001 21.4201 8.12001 21.4201 13.31C21.4201 18.5 17.2001 22.75 12.0001 22.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87011 6.07C7.70011 6.07 7.52011 6.01 7.38011 5.89C7.06011 5.61 7.03012 5.14 7.30012 4.83L10.1901 1.51C10.4601 1.2 10.9401 1.16 11.2501 1.44C11.5601 1.71 11.5901 2.19 11.3201 2.5L8.43012 5.81C8.28012 5.98 8.07011 6.07 7.87011 6.07Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2401 8.53C11.0901 8.53 10.9301 8.48 10.8001 8.39L7.42008 5.92C7.09008 5.68 7.02008 5.21 7.26008 4.88C7.50008 4.54 7.97008 4.47 8.31008 4.71L11.6801 7.17C12.0101 7.41 12.0901 7.88 11.8401 8.22C11.7001 8.43 11.4701 8.53 11.2401 8.53Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4577 17C13.3644 17 13.2712 16.9771 13.1851 16.916L10.9613 15.5038C10.4089 15.1527 10 14.3817 10 13.7023V10.5725C10 10.2595 10.2439 10 10.538 10C10.8321 10 11.076 10.2595 11.076 10.5725V13.7023C11.076 13.9771 11.2913 14.3817 11.5136 14.5191L13.7375 15.9313C13.9957 16.0916 14.0746 16.4427 13.924 16.7176C13.8164 16.9008 13.637 17 13.4577 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivetyIcon);
export default __webpack_public_path__ + "static/media/activety-icon.ab0f92c0be417421b71ee6d8fd4545a6.svg";
export { ForwardRef as ReactComponent };